<div class="common-wrapper">
  <div class="main-hd-txt">
    <h4>
      <pageheader [entity]="headerCommittee"></pageheader>
    </h4>
  </div>

  <div *ngIf="listView" class="top-btns">
    <grid [entities]="committee" [actionExclude]="['feedback','column']" [checkboxCol]="true"
      [entityColumns]="CommitteeColumns" [selectionField]="'Committee_Id'" [addEntityIcon]="'bi bi-plus-square'"
      [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'" (downloadEntities)="onExcelExport()"
      (addEntity)="addCommittee($event)" (editEntity)="editCommittee($event)"
      (refreshEntities)="refreshCommittee($event)" (deleteEntity)="deleteCommitte($event)"
      (onPaginationChange)="onPaginationChange($event)" [serverPagination]="true" [pageSizes]="pageSizes"
      [pageSize]="defaultPageSize" [skip]="pageSkip" (onFilterChange)="onFilterChange($event)"></grid>
  </div>

  <div *ngIf="!listView">
    <div class="row sub-head">
      <div class="col-md-7 text-bold">
        {{ formCaption }}
      </div>
      <div class="col-md-5 text-end">
        <button (click)="clearCommittee()" class="btn-3 bt-3-ic">
          <span>Clear</span>
        </button>
        <button (click)="revertChanges()" class="btn-3 bt-4-ic">
          <span>Revert Changes</span>
        </button>
        <button (click)="gotoBack()" class="btn-3 bt-4-ic">
          <span>Go Back</span>
        </button>
      </div>
    </div>

    <div class="tab-wrap">
      <!-- active tab on page load gets checked attribute -->
      <input type="radio" id="tab1" [(ngModel)]="aciveTab" value="1" name="tabGroup1" class="tab" checked />
      <label for="tab1">GENERAL</label>

      <input type="radio" id="tab2" [(ngModel)]="aciveTab" value="2" name="tabGroup1" class="tab" />
      <label for="tab2">MEMBER</label>

      <input type="radio" id="tab3" [(ngModel)]="aciveTab" value="3" name="tabGroup1" class="tab" />
      <label for="tab3">SECRETARY</label>

      <input type="radio" id="tab4" [(ngModel)]="aciveTab" value="4" name="tabGroup1" class="tab" />
      <label for="tab4">CHAIRMAN</label>

      <input type="radio" id="tab5" [(ngModel)]="aciveTab" value="5" name="tabGroup1" class="tab" />
      <label for="tab5">PERMANENT INVITEES</label>

      <div class="tab__content">
        <div class="container-fluid" [hidden]="aciveTab!=1">
          <div class="col-md-12 row ">
            <div class="btn-outer-box">
              <div class="btn-box-rt">
                <button (click)="goToNextTab()" type="button" title="Next Tab" class="next-btn-head">Next <i
                    class="bi bi-arrow-right-circle"></i></button>
              </div>
              <div class="btn-box-rt">
                <button (click)="save($event,true)" [disabled]="saveDisabled" type="button" title="Save Current Tab"
                  class="save-btn-head"><i class="bi bi-file-earmark-plus"></i> Save</button>
              </div>
              <div class="btn-box-rt">
                <button (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab"><i
                    class="bi bi-arrow-left-circle"></i> Back</button>
              </div>
            </div>

          </div>
          <div class="row mt-2">
            <div class="col-md-4">
              <textbox [caption]="'Meeting Type Name'" [formData]="entity" [maxlength]="200" [mandatory]="true"
                [fieldName]="'CommitteeName'" [name] ="'meetingtype'" [(ngModel)]="entity.CommitteeName" ngDefaultControl>
              </textbox>
            </div>
            <div class="col-md-4 mb-2">
              <textbox [caption]="'Code'" [formData]="entity" [maxlength]="10" [mandatory]="true"
                [fieldName]="'ShortName'" [(ngModel)]="entity.ShortName" ngDefaultControl>
              </textbox>
            </div>
            <div class="col-md-4">
              <dropdown [caption]="'Meeting Group'" [formData]="entity" [data]="Meetingtype" [class]="'form-control'"
                [mandatory]="true" [filterable]="true" (filterChanged)="getAllMeeting_type($event)"
                [(ngModel)]="entity.MeetingType_Id" [textField]="'MeetingTypeName'" [valueField]="'MeetingType_Id'"
                [fieldName]="'MeetingType_Id'" [selectedItem]="selectedmeeting" ngDefaultControl>
              </dropdown>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <dropdown [caption]="'Organising Department'" [name]="'Department_Id'" [formData]="entity" [data]="departments"
                [class]="'form-control'" [mandatory]="true" [filterable]="true" 
                (filterChanged)="getAllDepartments($event)" [(ngModel)]="entity.Department_Id"
                [textField]="'DepartmentName'" [valueField]="'Department_Id'" [fieldName]="'Department_Id'"
                [selectedItem]="_selectedDepartment" ngDefaultControl>
              </dropdown>
            </div>
            <div class="col-md-4">
              <datepicker [caption]="'Date Of Formation'" [placeholder]="'Date Of Formation'" [mandatory]="true"
                [datePicker]="true" [fieldName]="'DateOfFormation'" [(ngModel)]="entity.DateOfFormation"
                [formData]="entity"></datepicker>
            </div>
            <div class="col-md-4">
              <dropdown [caption]="'Quorum Options'" [formData]="entity" [data]="basicmaster" [class]="'form-control'"
                [mandatory]="false" [filterable]="true" (filterChanged)="getAllQuorumOptions($event)"
                [(ngModel)]="entity.QuorumOptions_Id" [textField]="'DisplayText'" [valueField]="'DisplayValue'"
                [fieldName]="'DisplayText'" [selectedItem]="selectedQuorum" ngDefaultControl>
              </dropdown>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-4">
              <textbox [caption]="'Quorum Value'" [formData]="entity" [maxlength]="5" [mandatory]="false"
                [fieldName]="'QuorumValue'" [(ngModel)]="entity.QuorumValue" (keypress)="numberOnly($event)"
                ngDefaultControl>
              </textbox>
            </div>
            <div class="col-md-4">
              <label for="file">Act</label>
              <kendo-multiselect [data]="actdata" [filterable]="true" [textField]="'ActName'" [valueField]="'Act_Id'"
                (filterChange)="getAllact($event)" [class]="'form-control'" [placeholder]="'Select Act'"
                [(ngModel)]="entity.Act" ngDefaultControl></kendo-multiselect>
            </div>
            <div class="col-md-4">
              <label for="file">Organizer</label>
              <kendo-multiselect [data]="organizerdata" [filterable]="true" [textField]="'UserName'"
                (filterChange)="getAllOrganizer($event)" [class]="'form-control'" [valueField]="'Emp_Ref_Id'"
                [placeholder]="'Select Organizer'" [(ngModel)]="entity.Organizer" ngDefaultControl></kendo-multiselect>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <label for="file">Departments</label>
              <kendo-multiselect [data]="multidepartmentdata" [filterable]="true" [textField]="'DepartmentName'"
                (filterChange)="getAllMultiDepartment($event)" [class]="'form-control'" [valueField]="'Department_Id'"
                [placeholder]="'Select Department'" [(ngModel)]="entity.multidepartment"
                ngDefaultControl></kendo-multiselect>
            </div>
            <div class="col-md-4">
              <textbox [caption]="'Description'" [formData]="entity" [maxlength]="1000" [mandatory]="false"
                [multiline]="true" [fieldName]="'TIttle'" [(ngModel)]="entity.Tittle" ngDefaultControl>
              </textbox>
            </div>
            <div class="col-md-4">
              <!-- <div class="col-md-4"> -->
                <checkbox [caption]="' Continuous Numbering'" [(ngModel)]="entity.ContinuousNumbering"></checkbox>
              <!-- </div> -->
            </div>
          </div>
          <div class="row"> 
            <div class="col-md-4">
              <checkbox [caption]="' Active'" [(ngModel)]="entity.IsActive"></checkbox>
            </div>
            <div class="col-md-8">
            <label for="file">Charted Document</label>
            <input id="file-input" type="file" (change)="fileChanged($event);" accept=".pdf,.doc,.docx" />
            <a id="link" download>{{download}}</a>
            <input type="button" id="downloadbutton"  *ngIf="this.isDownloadButtonVisible"
                            (click)="downloadFunction(entity)" value="Download" downloadLink/>
            <span>
              <input type="button" id="removeImage1" class="close" *ngIf="this.isButtonVisible"
                (click)="removeImage($event);" value="x" />
            </span></div>
          </div>

        </div>
      </div>

      <div class="tab__content">
        <div class="container-fluid" [hidden]="aciveTab!=2">
          <div class="col-md-12 row ">
            <div class="btn-outer-box">
              <div class="btn-box-rt">
                <button (click)="goToNextTab()" type="button" title="Next Tab" class="next-btn-head">Next <i
                    class="bi bi-arrow-right-circle"></i></button>
              </div>
              <div class="btn-box-rt">
                <button (click)="save_member($event,Memberarray)" [disabled]="memberdisabled" type="button"
                  title="Save Current Tab" class="save-btn-head"><i class="bi bi-file-earmark-plus"></i> Save</button>
              </div>
              <div class="btn-box-rt">
                <button (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab"><i
                    class="bi bi-arrow-left-circle"></i> Back</button>
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-md-4">
              <dropdown [caption]="'Member'" [formData]="committeememberentity" [data]="member_employees"
                [class]="'form-control'" [mandatory]="true" [filterable]="true"
                (filterChanged)="getAllEmployee_member($event)" [(ngModel)]="committeememberentity.Emp_Ref_Id"
                [textField]="'EmployeeName'" [valueField]="'Emp_Ref_Id'" [fieldName]="'Emp_Ref_Id'"
                (selectionChanged)="setMemberEmployee($event)" [selectedItem]="selectedMember" ngDefaultControl>
              </dropdown>
            </div>
            <div class="col-md-4">
              <div class="form-input">
                <datepicker [name]="'MemberJoiningDate'" [caption]="'Joining Date'" [placeholder]="'Joining Date'"
                  [mandatory]="true" [datePicker]="true" [fieldName]="'MemberJoiningDate'"
                  [(ngModel)]="committeememberentity.MemberJoiningDate" [formData]="committeememberentity"
                  ngDefaultControl></datepicker>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 mb-2">
              <checkbox [caption]="' Sitting Fee'" [(ngModel)]="committeememberentity.SittingFeeApplicable"
                (change)="checkValue(committeememberentity.SittingFeeApplicable?true:false)"></checkbox>
            </div>
          </div>

          <div class="row">
            <ng-container *ngIf="showsittingfee">
              <div class="col-md-4 mb-2">
                <textbox [caption]="'Sitting Fee (Amount)'" [formData]="committeememberentity" [maxlength]="6"
                  [mandatory]="true" [fieldName]="'TIttle'" (keypress)="numberOnly($event)"
                  [(ngModel)]="committeememberentity.SittingFee" ngDefaultControl>
                </textbox>
              </div>
              <div class="col-md-4 mb-2">
                <datepicker [caption]="'Sitting Fee Effective From'" [placeholder]="'Sitting Fee Effective From'"
                  [mandatory]="true" [datePicker]="true" [fieldName]="'SittingFeeEffectiveFrom'"
                  [(ngModel)]="committeememberentity.SittingFeeEffectiveFrom" [formData]="committeememberentity">
                </datepicker>
              </div>
              <div class="col-md-4 mb-2">
                <datepicker [caption]="'Sitting Fee Effective To'" [placeholder]="'Sitting Fee Effective To'"
                  [mandatory]="false" [datePicker]="true" [fieldName]="'SittingFeeEffectiveTo'"
                  [(ngModel)]="committeememberentity.SittingFeeEffectiveTo" [formData]="committeememberentity">
                </datepicker>
              </div>
            </ng-container>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="chrg_sec">
                <div class="thr_form">
                  <label for="exampleFormControlSelect1" class="label label-1">Membership Expiry</label>
                  <div class="thr_sub_form">
                    <div class="col-md-4">
                      <div class="form-check spc_here">
                        <input class="form-check-input" type="radio" name="MemberRadios" id="MemberRadios1" ischecked
                          (change)="MemberRadios1($event)" [(ngModel)]="flag" [value]="'Date'" />
                        <label class="form-check-label label_sl" for="exampleRadios1">
                          Date
                        </label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-check spc_here">
                        <input class="form-check-input" type="radio" name="MemberRadios" id="MemberRadios2"
                          (change)="MemberRadios2($event)" [(ngModel)]="flag" [value]="'Tenure'"
                          checked="entity.ischecked" />
                        <label class="form-check-label label_sl" for="exampleRadios2">
                          Tenure
                        </label>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <ng-container *ngIf="showDateMember">
                        <datepicker [caption]="'Membership Till'" [placeholder]="'Till'" [mandatory]="true"
                          [datePicker]="true" [fieldName]="'MemberInChargeTillDate'"
                          [(ngModel)]="committeememberentity.MemberInChargeTillDate" [formData]="committeememberentity">
                        </datepicker>

                      </ng-container>
                      <ng-container *ngIf="showTenureMember">
                        <textbox [caption]="'Membership years'" [placeholder]="'Till'"
                          [formData]="committeememberentity" [maxlength]="5" [mandatory]="true"
                          [fieldName]="'Membership Expiry'" (keypress)="tenureValue($event)"
                          [(ngModel)]="committeememberentity.MemberInChargeTillTenure" ngDefaultControl #box>
                        </textbox>
                      </ng-container>
                    </div>
                  </div>
                </div>   
                <div class="row btn-outer-box-add col-md-12">
                  <span>
                    <button (click)="getval()" title="Add" class="add-btn-head" type="button"><i
                        class="bi bi-plus-circle"></i> Add
                    </button>
                    <button (click)="clearMember()" title="Clear" class="clear-btn-head" type="button"><i
                        class="bi bi-backspace"></i> Clear</button>
                  </span>
                </div>

                <div class="row">
                  <div class="thr_form_2">
                    <div class="top-btns">
                      <grid [entities]="entity.committeememberarray"
                        [actionExclude]="['feedback','column','add','refresh']" [checkboxCol]="true"
                        [checkboxCol]="true" showSelectAll="true" [entityColumns]="MemberColumns"
                        [selectionField]="'Emp_Ref_Id'" [showActions]="true" (editEntity)="editMember($event)"
                        (deleteEntity)="deleteMember($event)" (downloadEntities)="onExcelExport1()" [pageSize]="10">
                      </grid>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tab__content">
        <div class="container-fluid" [hidden]="aciveTab!=3">
          <div class="col-md-12 row ">
            <div class="btn-outer-box">
              <div class="btn-box-rt">
                <button (click)="goToNextTab()" type="button" title="Next Tab" class="next-btn-head">Next <i
                    class="bi bi-arrow-right-circle"></i></button>
              </div>
              <div class="btn-box-rt">
                <button (click)="saveSecretaryDetails($event,true)" [disabled]="secretarydisabled" type="button"
                  title="Save Current Tab" class="save-btn-head"><i class="bi bi-file-earmark-plus"></i> Save</button>
              </div>
              <div class="btn-box-rt">
                <button (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab"><i
                    class="bi bi-arrow-left-circle"></i> Back</button>
              </div>
            </div>
          </div>
          <div class="row mt-2">

            <div class="col-md-4">
              <dropdown [caption]="'Secretary'" [formData]="entity" [data]="Secratary_employees"
                [class]="'form-control'" [mandatory]="true" [filterable]="true" (filterChanged)="getAllEmployee($event)"
                (selectionChanged)="setSecretaryEmployee($event)" [(ngModel)]="entity.Secretary_Emp_Ref_Id"
                [textField]="'EmployeeName'" [valueField]="'Emp_Ref_Id'" [fieldName]="'Emp_Ref_Id'"
                [selectedItem]="selectedEmployee" ngDefaultControl>
              </dropdown>
            </div>
            <div class="col-md-4">
              <div class="form-input">
                <datepicker [caption]="'Joining Date'" [placeholder]="'Joining Date'" [mandatory]="true"
                  [datePicker]="true" [fieldName]="'SecretaryJoiningDate'" [(ngModel)]="entity.SecretaryJoiningDate"
                  [formData]="entity"></datepicker>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="chrg_sec">
                <div class="thr_form">
                  <label for="exampleFormControlSelect1" class="label label-1">In Charge Till</label>
                  <div class="thr_sub_form">
                    <div class="form-check spc_here">
                      <input class="form-check-input" type="radio" name="SecretaryRadios1"
                        (change)="SecretaryRadios1($event)" id="SecretaryRadios1" [(ngModel)]="flag" [value]="1" />
                      <label class="form-check-label label_sl" for="SecretaryRadios1">
                        Date
                      </label>
                    </div>
                    <div class="form-check spc_here">
                      <input class="form-check-input" type="radio" name="SecretaryRadios2"
                        (change)="SecretaryRadios2($event)" id="SecretaryRadios2" checked="entity.ischecked"
                        [(ngModel)]="flag" [value]="2" />
                      <label class="form-check-label label_sl" for="SecretaryRadios2">
                        Tenure
                      </label>
                    </div>
                    <ng-container *ngIf="showDate">
                      <div class="col-md-4">
                        <datepicker [caption]="'Till'" [placeholder]="'Till'" [mandatory]="true" [datePicker]="true"
                          [fieldName]="'SecretaryInChargeTillDate'" [(ngModel)]="entity.SecretaryInChargeTillDate"
                          [formData]="entity">
                        </datepicker>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="showTenure">
                      <div class="col-md-4">
                        <textbox [caption]="'In Charge Till(years)'" [placeholder]="'Till'" [formData]="entity"
                          [maxlength]="5" [mandatory]="true" [fieldName]="'TIttle'" (keypress)="tenureValue($event)"
                          [(ngModel)]="entity.SecretaryInChargeTillTenure" ngDefaultControl>
                        </textbox>
                      </div>
                    </ng-container>
                    <div class="col-md-4"></div>
                    <div class="row btn-outer-box-add col-md-12">
                      <span>
                        <button (click)="getval_secretary()" title="Add" class="add-btn-head" type="button"><i
                            class="bi bi-plus-circle"></i> Add
                        </button>
                        <button (click)="clearSecretary()" title="Clear" class="clear-btn-head" type="button"><i
                            class="bi bi-backspace"></i> Clear</button>
                      </span>
                    </div>
                    <div class="row">
                      <div class="thr_form_2">
                        <div class="top-btns">
                          <grid [entities]="entity.secretaryarray"
                            [actionExclude]="['feedback','column','add','refresh']" [checkboxCol]="true"
                            [checkboxCol]="true" showSelectAll="true" [entityColumns]="SecretaryColumns"
                            [selectionField]="'Secretary_Emp_Ref_Id'" [showActions]="true"
                            (editEntity)="editSecretarydetails($event)" (deleteEntity)="deleteSecretary($event)"
                            (downloadEntities)="onExcelExport3()" [pageSize]="10">
                          </grid>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tab__content">
        <div class="container-fluid" [hidden]="aciveTab!=4">
          <div class="col-md-12 row ">
            <div class="btn-outer-box">
              <div class="btn-box-rt">
                <button (click)="goToNextTab()" type="button" title="Next Tab" class="next-btn-head">Next <i
                    class="bi bi-arrow-right-circle"></i></button>
              </div>
              <div class="btn-box-rt">
                <button (click)="saveChairmanDetails($event,false)" [disabled]="chairmandisabled" type="button"
                  title="Save Current Tab" class="save-btn-head"><i class="bi bi-file-earmark-plus"></i> Save</button>
              </div>
              <div class="btn-box-rt">
                <button (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab"><i
                    class="bi bi-arrow-left-circle"></i> Back</button>
              </div>

            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-4">
              <dropdown [caption]="'Chairman'" [formData]="entity" [data]="Chairman_employees" [class]="'form-control'"
                [mandatory]="true" [filterable]="true" (filterChanged)="getAllEmployee_Chairman($event)"
                (selectionChanged)="setChairmanEmployee($event)" [(ngModel)]="entity.Chairman_Emp_Ref_Id"
                [textField]="'EmployeeName'" [valueField]="'Emp_Ref_Id'" [fieldName]="'Emp_Ref_Id'"
                [selectedItem]="selectedChairman" ngDefaultControl>
              </dropdown>
            </div>
            <div class="col-md-4">
              <div class="form-input">
                <datepicker [caption]="'Joining Date'" [placeholder]="'Joining Date '" [mandatory]="true"
                  [datePicker]="true" [fieldName]="'ChairmanJoiningDate'" [(ngModel)]="entity.ChairmanJoiningDate"
                  [formData]="entity"></datepicker>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="chrg_sec">
                <div class="thr_form">
                  <label for="exampleFormControlSelect1" class="label label-1">Hold Office Till</label>
                  <div class="thr_sub_form">
                    <div class="form-check spc_here">
                      <input class="form-check-input" type="radio" name="ChairmanRadios1" id="ChairmanRadios1"
                        (change)="ChairmanRadios1($event)" [(ngModel)]="flag" [value]="1" />
                      <label class="form-check-label label_sl" for="exampleRadios1">
                        Date
                      </label>
                    </div>
                    <div class="form-check spc_here">
                      <input class="form-check-input" type="radio" name="ChairmanRadios2" id="ChairmanRadios2"
                        (change)="ChairmanRadios2($event)" [(ngModel)]="flag" [value]="2" />
                      <label class="form-check-label label_sl" for="exampleRadios2">
                        Tenure
                      </label>
                    </div>
                    <ng-container *ngIf="showDateChairman">
                      <div class="col-md-4">
                        <datepicker [caption]="'Till'" [placeholder]="'Till'" [mandatory]="true" [datePicker]="true"
                          [fieldName]="'ChairmanInChargeTillDate'" [(ngModel)]="entity.ChairmanInChargeTillDate"
                          [formData]="entity">
                        </datepicker>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="showTenureChairman">
                      <div class="col-md-4">
                        <textbox [caption]="'Hold Office Till(years)'" [formData]="entity" [maxlength]="5"
                          [mandatory]="true" [fieldName]="'Till'" (keypress)="tenureValue($event)"
                          [(ngModel)]="entity.ChairmanInChargeTillTenure" ngDefaultControl>
                        </textbox>
                      </div>
                    </ng-container>
                  </div>
                  <div class="row btn-outer-box-add col-md-12">
                    <span>
                      <button (click)="getval_chairman()" title="Add" class="add-btn-head" type="button"><i
                          class="bi bi-plus-circle"></i> Add
                      </button>
                      <button (click)="clearChairman()" title="Clear" class="clear-btn-head" type="button"><i
                          class="bi bi-backspace"></i> Clear</button>
                    </span>
                  </div>
                  <div class="row">
                    <div class="thr_form_2">
                      <div class="top-btns">
                        <grid [entities]="entity.Chairmanarray" [actionExclude]="['feedback','column','add','refresh']"
                          [checkboxCol]="true" [checkboxCol]="true" showSelectAll="true"
                          [entityColumns]="chairmanColumns" [selectionField]="'Chairman_Emp_Ref_Id'"
                          [showActions]="true" (editEntity)="editchairmandetails($event)"
                          (deleteEntity)="deletechairman($event)" (downloadEntities)="onExcelExport4()" [pageSize]="10">
                        </grid>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tab__content">
        <div class="container-fluid" [hidden]="aciveTab!=5">
          <div class="col-md-12 row ">

            <div class="btn-outer-box">
              <div class="btn-box-rt">
                <button (click)="save_permanentInvitees($event)" [disabled]="saveDisabled" type="button"
                  title="Save Current Tab" class="save-btn-head"><i class="bi bi-file-earmark-plus"></i> Save</button>
              </div>
              <div class="btn-box-rt">
                <button (click)="goToBackTab()" class="go-back-btn-head" [disabled]="permanentdisabled"
                  title="Back Tab"><i class="bi bi-arrow-left-circle"></i> Back</button>
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-md-4">
              <dropdown [caption]="'Permanent Invitees'" [formData]="committeepermenantInviteesentity"
                [data]="Employee_inviteedata" [class]="'form-control'" [mandatory]="true" [filterable]="true"
                (filterChanged)="getAllEmployee_Invitees($event)"
                [(ngModel)]="committeepermenantInviteesentity.Emp_Ref_Id" [textField]="'EmployeeName'"
                [valueField]="'Emp_Ref_Id'" [fieldName]="'EmployeeName'" (selectionChanged)="setInviteeEmployee($event)"
                [selectedItem]="selectedInvitees" ngDefaultControl>
              </dropdown>
            </div>
            <div class="col-md-4">
              <div class="form-input">
                <datepicker [caption]="'Joining Date'" [placeholder]="'Joining Date'" [mandatory]="true"
                  [datePicker]="true" [fieldName]="'PermenantInvJoiningDate'"
                  [(ngModel)]="committeepermenantInviteesentity.PermenantInvJoiningDate" [formData]="entity">
                </datepicker>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="chrg_sec">
                <div class="thr_form">
                  <label for="exampleFormControlSelect1" class="label label-1">In Charge Till</label>
                  <div class="thr_sub_form">
                    <div class="form-check spc_here">
                      <input class="form-check-input" type="radio" name="exampleRadiosPerm"
                        (change)="permInvChangeradio1($event)" id="permInvChangeradio1" />
                      <label class="form-check-label label_sl" for="exampleRadios1Perm" value="1">
                        Date
                      </label>
                    </div>
                    <div class="form-check spc_here">
                      <input class="form-check-input" type="radio" name="exampleRadiosPerm"
                        (change)="permInvChangeradio2($event)" id="permInvChangeradio2" />
                      <label class="form-check-label label_sl" for="exampleRadios2Perm" value="0">
                        Years
                      </label>
                    </div>
                    <ng-container *ngIf="showDatePerm">
                      <div class="col-md-4">
                        <datepicker [caption]="'Till'" [placeholder]="'Till'" [mandatory]="true" [datePicker]="true"
                          [fieldName]="'PermenantInvInChargeTillDate'"
                          [(ngModel)]="committeepermenantInviteesentity.PermenantInvInChargeTillDate"
                          [formData]="entity">
                        </datepicker>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="showTenurePerm">
                      <div class="col-md-4">
                        <textbox [caption]="'Till'" [placeholder]="'Till'" [formData]="entity" [maxlength]="5"
                          [mandatory]="true" [fieldName]="'TIttle'" (keypress)="tenureValue($event)"
                          [(ngModel)]="committeepermenantInviteesentity.PermenantInvInChargeTillTenure"
                          ngDefaultControl>
                        </textbox>
                      </div>
                    </ng-container>

                    <div class="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row btn-outer-box-add col-md-12">
            <span>
              <button (click)="getval_Permenant()" title="Add" class="add-btn-head" type="button"><i
                  class="bi bi-plus-circle"></i> Add
              </button>
              <button (click)="clearPermenant()" title="Clear" class="clear-btn-head" type="button"><i
                  class="bi bi-backspace"></i> Clear</button>
            </span>
          </div>

          <div class="row">
            <div class="thr_form_2">
              <div class="top-btns">
                <grid [entities]="entity.permenantInviteesgrid" [actionExclude]="['feedback','column','add','refresh']"
                  [checkboxCol]="true" showSelectAll="true" [entityColumns]="permenantInviteesgridcolumns"
                  [selectionField]="'Emp_Ref_Id'" (editEntity)="editPermenantInvitees($event)"
                  (deleteEntity)="deletepermenantInvitees($event)" [showActions]="true" [pageSize]="10"
                  (downloadEntities)="onExcelExport2()">
                </grid>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #view let-dataItem let-rowIndex="rowIndex">
  <i class="bi bi-eye-fill" (click)="open(dataItem)"></i>
</ng-template>

<kendo-dialog title="Meeting Type Details" *ngIf="opened" (close)="close()" [height]="500" [width]="1000">
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-4 br-table-data">
        <label for="email" class="label label-1">Meeting Type Name : </label> {{details.CommitteeName }}
      </div>
      <div class="col-md-4 br-table-data">
        <label for="email" class="label label-1">Code : </label> {{details.ShortName}}
      </div>
      <div class="col-md-4 br-table-data">
        <label for="Meeting Group" class="label label-1">Meeting Group : </label> {{details.MeetingTypeName}}
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 br-table-data">
        <label for="DepartmentName" class="label label-1">Organising Department : </label> {{details.DepartmentName}}
      </div>
      <div class="col-md-4 br-table-data">
        <label for="email" class="label label-1">Date Of Formation : </label> {{details.DateOfFormationStr}}
      </div>
      <div class="col-md-4 br-table-data">
        <label for="QuorumOptionValue" class="label label-1">Quorum Options : </label> {{details.QuorumOptionValue}}
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 br-table-data">
        <label for="QuorumValue" class="label label-1">Quorum Value : </label> {{details.QuorumValue}}
      </div>
      <div class="col-md-4 br-table-data">
        <label for="ContinuousNumbering" class="label label-1">Continuous Numbering : </label>
        {{details.ContinuousNumbering}}
      </div>
      <div class="col-md-4 br-table-data">
        <label for="Tittle" class="label label-1">Description : </label> {{details.Tittle}}
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 br-table-data">
        <label for="ChairmanName" class="label label-1">Chairman Name : </label> {{details.ChairmanName}}
      </div>
      <div class="col-md-4 br-table-data">
        <label for="email" class="label label-1">Chairman Joining Date : </label> {{details.ChairmanJoiningDateStr}}
      </div>
      <div class="col-md-4 br-table-data">
        <label for="email" class="label label-1">Chairman InCharge TillDate :
        </label> {{details.ChairmanInChargeTillDateStr}}
      </div>
      <div class="col-md-4 br-table-data">
        <label for="email" class="label label-1">Chairman InCharge Till Tenure : </label>
        {{details.ChairmanInChargeTillTenure}}
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 br-table-data">
        <label for="SecretaryName" class="label label-1">Secretary Name : </label> {{details.SecretaryName }}
      </div>
      <div class="col-md-4 br-table-data">
        <label for="SecretaryJoiningDate" class="label label-1">Secretary Joining Date : </label>
        {{details.SecretaryJoiningDateStr}}
      </div>
      <div class="col-md-4 br-table-data">
        <label for="SecretaryInChargeTillDate" class="label label-1">Secretary InCharge Till Date : </label>
        {{details.SecretaryInChargeTillDateStr}}
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 br-table-data">
        <label for="SecretaryInChargeTillTenure" class="label label-1">Secretary InCharge Till Tenure : </label>
        {{details.SecretaryInChargeTillTenure}}
      </div>
    </div>
    <br />
    <div>
      <div class="col-md-7 text-bold">
        {{ OrganizerCaption }}
      </div>
      <grid [entities]="details.Organizer"
        [actionExclude]="['feedback','column','add','edit','delete','download','refresh']" [checkboxCol]="true"
        [entityColumns]="organizerColumns"></grid><br><br>
    </div>
    <div>
      <div class="col-md-7 text-bold">
        {{ MultiDepartmentCaption }}
      </div>
      <grid [entities]="details.multidepartment"
        [actionExclude]="['feedback','column','add','edit','delete','download','refresh']" [checkboxCol]="true"
        [entityColumns]="multidepartmentColumns"></grid><br><br>
    </div>
    <div>
      <div class="col-md-7 text-bold">
        {{ actCaption }}
      </div>
      <grid [entities]="selected_acts"
        [actionExclude]="['feedback','column','add','edit','delete','download','refresh']" [checkboxCol]="true"
        [entityColumns]="actColumns"></grid><br><br>
    </div>
    <div>
      <div class="col-md-7 text-bold">
        {{memberCaption}}
      </div>
      <grid [entities]="selected_members"
        [actionExclude]="['feedback','column','add','edit','delete','download','refresh']" [checkboxCol]="true"
        [entityColumns]="MemberColumns"></grid><br><br>
    </div>
    <div>
      <div class="col-md-7 text-bold">
        {{PermanentCaption}} </div>
      <grid [entities]="selected_Invitees"
        [actionExclude]="['feedback','column','add','edit','delete','download','refresh']" [checkboxCol]="true"
        [entityColumns]="permenantInviteesgridcolumns"></grid>

    </div>
  </div>
</kendo-dialog>

<kendo-excelexport [data]="committee.data" [collapsible]="true" fileName="Committee.xlsx" #excelexport>
  <kendo-excelexport-column field="SlNo" title="SlNo" [width]="200">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="CommitteeName" title="Meeting Type" [width]="200">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="ShortName" title="Code" [width]="200">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="MeetingTypeName" title="Meeting Group" [width]="200">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="DepartmentName" title="Department" [width]="200">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="DateOfFormation" title="Date Of Formation" [width]="200">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="Continuous Numbering" title="Continuous Numbering" [width]="200">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="Active" title="Active" [width]="200">
  </kendo-excelexport-column>
</kendo-excelexport>

<kendo-excelexport [data]="entity.permenantInviteesgrid" [collapsible]="true" fileName="permenant Invitees.xlsx"
  #excelexport2>
  <!-- <kendo-excelexport-column field="SlNo" title="SlNo" [width]="200">
  </kendo-excelexport-column> -->
  <kendo-excelexport-column field="EmployeeName" title="Employee Name" [width]="200">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="DesignationName" title="Designation" [width]="200">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="PermenantInvJoiningDate" title="Joining Date" [width]="200">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="PermenantInvExpiryDate" title="In Charge Till(Date/Years)" [width]="200">
  </kendo-excelexport-column>
</kendo-excelexport>

<kendo-excelexport [data]="entity.Chairmanarray" [collapsible]="true" fileName="Chairman.xlsx" #excelexport4>
  <!-- <kendo-excelexport-column field="SlNo" title="SlNo" [width]="200">
  </kendo-excelexport-column> -->
  <kendo-excelexport-column field="ChairmanName" title="Chairman Name" [width]="200">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="ChairmanJoiningDate" title="Joining Date" [width]="200">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="ChairmanInChargeTillDate" title="In Charge Till Date" [width]="200">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="ChairmanInChargeTillTenure" title="In Charge Till Year(in Date)" [width]="200">
  </kendo-excelexport-column>
</kendo-excelexport>

<kendo-excelexport [data]="entity.secretaryarray" [collapsible]="true" fileName="Secretary.xlsx" #excelexport3>
  <!-- <kendo-excelexport-column field="SlNo" title="SlNo" [width]="200">
  </kendo-excelexport-column> -->
  <kendo-excelexport-column field="SecretaryName" title="Employee Name" [width]="200">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="SecretaryJoiningDateStr" title="Joining Date" [width]="200">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="SecretaryInChargeTillDateStr" title="In Charge Till Date" [width]="200">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="SecretaryInChargeTillTenure" title="In Charge Till Year" [width]="200">
  </kendo-excelexport-column>
</kendo-excelexport>

<kendo-excelexport [data]="entity.committeememberarray" [collapsible]="true" fileName="Member.xlsx" #excelexport1>
  <kendo-excelexport-column field="EmployeeName" title="Member" [width]="200">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="JoiningDate" title="Joining Date" [width]="200">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="MembershipExpiryDate" title="Membership Expiry" [width]="200">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="SittingFee" title="Sitting Fee" [width]="200">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="SittingFeeEffectiveFrom" title="Effective From" [width]="200">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="SittingFeeEffectiveTo" title="Effective To" [width]="200">
  </kendo-excelexport-column>
  <kendo-excelexport-column field="Active" title="Active" [width]="200">
  </kendo-excelexport-column>
</kendo-excelexport>